import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";


export const FetchUserDetails = createAsyncThunk(
  "FetchUserDetails",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`dashboard/userDetails`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);







